import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
import { ManualsVisual } from './ManualsVisual';
export function FinalCTA() {
  return <section className="py-24 bg-ed-black relative overflow-hidden border-t border-white/5" data-id="element-158">
      {/* Dramatic Background */}
      <div className="absolute inset-0 bg-radial-green-bottom opacity-40 pointer-events-none" data-id="element-159"></div>
      <div className="absolute inset-0 bg-grid-pattern opacity-10 pointer-events-none" data-id="element-160"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12 flex justify-center scale-75 sm:scale-100 origin-bottom" data-id="element-162">
          <ManualsVisual data-id="element-163" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-164">
          <h2 className="text-5xl sm:text-6xl md:text-7xl font-black uppercase tracking-tight text-white mb-6 leading-[1.1]" data-id="element-165">
            Aprendé hoy. <br data-id="element-166" />
            <span className="text-ed-green text-glow" data-id="element-167">
              Empezá a construir tu futuro profesional.
            </span>
          </h2>

          <p className="text-xl sm:text-2xl text-zinc-300 mb-12 font-medium max-w-2xl mx-auto" data-id="element-168">
            No importa si hoy empezás desde cero.{' '}
            <br className="hidden sm:block" data-id="element-169" />
            Lo importante es empezar bien.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8" data-id="element-170">
            <a href="https://academiaed.com/cart/52970052682037:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-ed-dark border-2 border-zinc-700 text-white px-10 py-5 rounded-lg font-bold uppercase tracking-wide text-lg hover:border-ed-green hover:bg-ed-green/5 transition-all" data-id="element-171">
              Acceder a Plan Profesional
            </a>
            <a href="https://academiaed.com/cart/52970094002485:1" target="_blank" rel="noopener noreferrer" className="inline-flex flex-col items-center justify-center gap-1.5 bg-ed-green text-ed-black px-10 py-4 rounded-lg uppercase hover:bg-ed-green-dark transition-all glow-green hover:scale-[1.02] active:scale-[0.98]" data-id="element-172">
              <span className="inline-flex items-center gap-2 font-black tracking-wide text-lg" data-id="element-173">
                Acceder a Plan Premium
                <ArrowRight className="w-6 h-6" data-id="element-174" />
              </span>
              <span className="inline-flex items-center gap-1.5 bg-ed-black text-ed-green text-xs font-black tracking-wide normal-case px-2.5 py-1 rounded-full" data-id="element-175">
                <Sparkles className="w-3 h-3" data-id="element-176" />
                12 cuotas sin interés
              </span>
            </a>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-3 sm:gap-6 text-sm font-semibold text-zinc-500 uppercase tracking-wider" data-id="element-177">
            <span data-id="element-178">Cupos limitados</span>
            <span className="w-1.5 h-1.5 rounded-full bg-ed-green/50" data-id="element-179"></span>
            <span data-id="element-180">Inicio próximo</span>
            <span className="w-1.5 h-1.5 rounded-full bg-ed-green/50" data-id="element-181"></span>
            <span data-id="element-182">Acceso inmediato al material</span>
          </div>
        </motion.div>
      </div>
    </section>;
}